import * as React from "react";
import getConfig from "next/config";
import { TrustedShopsWidgetComponent } from "@grandvisionhq/analytics";
import { useBloomreachCartConfiguration, useBloomreachDeliveryInfo, useBloomreachProtectionInfo, CmsComponentSlot } from "@grandvisionhq/bloomreach";
import { CartSlotsProvider, Context, Mappers, TealiumCartPageView, Cart } from "@grandvisionhq/carts-v2";
import { LoaderScreen, SupportFooter } from "@grandvisionhq/common";
import { Container } from "@grandvisionhq/elements";
import { InfoModal } from "@grandvisionhq/lib-visuals";
import { PaypalClientProvider } from "@grandvisionhq/payments";
import { DeliveryIndicatorProvider } from "@grandvisionhq/shipping";
import { useFeatureToggles, useIntl, ReduxPersistGate } from "@grandvisionhq/state";
import { monetate } from "@grandvisionhq/svc-monetate";
import { P as ProductRecommendationContainer } from "../../ProductRecommendationContainer.js";
import "@grandvisionhq/svc-tealium/events";
const Page = ({ store, delivery, paypalConfig }) => {
  const { cart, loading } = Context.useCart();
  const { isCartRecommendationsEnabled } = useFeatureToggles();
  const { getLabel, hasLabel, currency } = useIntl();
  const cartConfiguration = useBloomreachCartConfiguration();
  const policyItems = cartConfiguration?.policyItems;
  const deliveryInfo = useBloomreachDeliveryInfo();
  const { publicRuntimeConfig } = getConfig();
  const trustedShopsWidgetId = publicRuntimeConfig.trustedShops?.widgetId;
  const protectionInfo = useBloomreachProtectionInfo();
  const ProtectionInfoModal = React.useCallback(
    ({ isOpen, onClose }) => protectionInfo ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      InfoModal,
      {
        onModalClose: onClose,
        isOpen,
        image: protectionInfo.image ? {
          url: protectionInfo.image.url,
          alt: protectionInfo.image.alt ?? ""
        } : void 0,
        title: protectionInfo.title ?? "",
        richTextContent: protectionInfo.content.value ?? ""
      }
    )) : null,
    [protectionInfo]
  );
  const labels = React.useMemo(
    () => ({
      message: getLabel("support.title"),
      phoneNumber: hasLabel("support.phoneNumber") ? getLabel("support.phoneNumber") : void 0,
      email: hasLabel("support.emailAddress") ? getLabel("support.emailAddress") : void 0
    }),
    [hasLabel, getLabel]
  );
  React.useEffect(() => {
    if (!loading && cart === null) {
      monetate().trackCartPage([]);
    } else if (!loading && cart) {
      monetate().trackCartPage(Mappers.getViewModelCartRows(cart.lineItems, currency));
    }
  }, [cart, loading]);
  if (!store?.persistor) {
    console.error("Missing redux persistor");
    return null;
  }
  return /* @__PURE__ */ React.createElement(PaypalClientProvider, { settings: paypalConfig }, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/top-container" }), /* @__PURE__ */ React.createElement(ReduxPersistGate, { loading: /* @__PURE__ */ React.createElement(LoaderScreen, null), persistor: store.persistor }, /* @__PURE__ */ React.createElement(TealiumCartPageView, { cart, loading }, /* @__PURE__ */ React.createElement(DeliveryIndicatorProvider, { config: delivery.indicatorConfig, deliveryInfo }, /* @__PURE__ */ React.createElement(
    CartSlotsProvider,
    {
      slots: {
        ProtectionInfoModal
      }
    },
    /* @__PURE__ */ React.createElement(Container, { className: "cart-layout" }, /* @__PURE__ */ React.createElement(Cart, { policyItems }), /* @__PURE__ */ React.createElement(
      SupportFooter,
      {
        message: labels.message,
        phoneNumber: labels.phoneNumber,
        email: labels.email,
        cartConfiguration
      }
    ), trustedShopsWidgetId && /* @__PURE__ */ React.createElement(TrustedShopsWidgetComponent, { id: trustedShopsWidgetId }))
  )))), isCartRecommendationsEnabled && cart && cart.lineItems && cart.lineItems.length > 0 && /* @__PURE__ */ React.createElement(
    ProductRecommendationContainer,
    {
      recommendationContext: "CART",
      layout: "page",
      skus: cart.lineItems.map(
        (l) => l.type === "prescription-glasses" ? l.frame.sku : l.sku
      )
    }
  ), /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/bottom-container" }));
};
const SlotsProvider = CartSlotsProvider;
export {
  Page,
  SlotsProvider
};
//# sourceMappingURL=overview.js.map
